export const UPDATE_FILTER = 'UPDATE_FILTER'
export const UPDATE_POPULAR_TAG_FILTER = 'UPDATE_POPULAR_TAG_FILTER'
export const UPDATE_SELECTED_TYPE = 'UPDATE_SELECTED_TYPE'
export const CLEAR_TAGS_FILTERS = 'CLEAR_TAGS_FILTERS'
export const CLEAR_MY_TAGS_FILTERS = 'CLEAR_MY_TAGS_FILTERS'
export const CLEAR_POPULAR_TAG_FILTERS = 'CLEAR_POPULAR_TAG_FILTERS'
